/**
 * @file InstallationModal.js
 * @description A specific style of action modal for the user to reach out to an email. May also redirect them to their HR admin. For example, iNGAGED custom clients may be directed to one resource and Mercer clients may be directed elsewhere. We could eventually offer end user support for an upcharge. Could be agency specific with iNGAGED default.
 */

import style from './modals.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import InstallationInstructions from '../../installation-instructions/InstallationInstructions';
import { getText } from '../../../i18n';

/**
 * InstallationModal component, rendering a styled modal.
 * @param {ModalConfig} modalProps - The properties for configuring the modal.
 * @returns {React.ReactElement} The rendered component.
 */
const InstallationModal = ({ onHide }) => {
    return (
        <div className={`${style.container} modal-backdrop`}>
            <div
                className="modal fade show display-block"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div className={`modal-dialog modal-lg ${style.modalSizing}`}>
                    <div className={`modal-content ${style.modalContent}`}>
                        <div>
                            <div className="d-flex align-items-center justify-content-between">
                                <h2
                                    className={`modal-title font-weight-600 ${style.title}`}
                                    style={{ margin: 0, lineHeight: 1 }}
                                >
                                    {getText('msg_ad0bb58de6ed')}
                                </h2>

                                <button
                                    type="button"
                                    onClick={onHide}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        textDecoration: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    aria-label={getText('msg_bbfa773e5a63')}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 7 7"
                                        fill="none"
                                        aria-hidden="true"
                                        focusable="false"
                                        style={{
                                            display: 'inline-block',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <path
                                            d="M0.146447 0.146447C0.341709 -0.0488155 0.658291 -0.0488155 0.853553 0.146447L3.5 2.79289L6.14645 0.146447C6.34171 -0.0488155 6.65829 -0.0488155 6.85355 0.146447C7.04882 0.341709 7.04882 0.658291 6.85355 0.853553L4.20711 3.5L6.85355 6.14645C7.04882 6.34171 7.04882 6.65829 6.85355 6.85355C6.65829 7.04882 6.34171 7.04882 6.14645 6.85355L3.5 4.20711L0.853553 6.85355C0.658291 7.04882 0.341709 7.04882 0.146447 6.85355C-0.0488155 6.65829 -0.0488155 6.34171 0.146447 6.14645L2.79289 3.5L0.146447 0.853553C-0.0488155 0.658291 -0.0488155 0.341709 0.146447 0.146447Z"
                                            fill="#667085"
                                        />
                                    </svg>
                                    <span
                                        style={{
                                            marginLeft: 8,
                                            color: '#667085',
                                            lineHeight: 1,
                                        }}
                                    >
                                        {getText('msg_bbfa773e5a63')}
                                    </span>
                                </button>
                            </div>
                            <div
                                className={`${style.securitySectionSubtitle}`}
                                style={{ marginTop: 4 }}
                            >
                                {getText('msg_8bb6a107b1a5')}
                            </div>
                        </div>

                        <div
                            className={`modal-body text-center ${style.modalBody}`}
                        >
                            <InstallationInstructions />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

InstallationModal.propTypes = {
    onHide: PropTypes.func.isRequired,
};

export default InstallationModal;
